import { Preloader } from '@cian/components';
import * as React from 'react';
import { EGalleryItemStatus, GalleryItem } from '../item';

const style = require('./index.css');

export interface IGalleryItemPreloaderProps extends Readonly<{ children?: React.ReactNode }> {}

export interface IGalleryItemPreloaderState {
  status: EGalleryItemStatus;
}

export class GalleryItemPreloader extends React.Component<IGalleryItemPreloaderProps, IGalleryItemPreloaderState> {
  public state = {
    status: EGalleryItemStatus.Pending,
  };

  // tslint:disable-next-line:no-any
  private item: GalleryItem<any, any>;

  public componentDidMount() {
    if (this.state.status === EGalleryItemStatus.Pending) {
      this.item.load();
    }
  }

  public render() {
    return (
      <div className={style.container}>
        {this.renderLoader()}
        {/* tslint:disable-next-line:no-any */}
        {React.cloneElement(React.Children.only(this.props.children as any), {
          // tslint:disable-next-line:no-any
          ref: (item: GalleryItem<any, any>) => (this.item = item),
          onStateChange: (state: EGalleryItemStatus) => {
            this.setState({ status: state });
          },
        })}
      </div>
    );
  }

  private renderLoader() {
    if (this.state.status === EGalleryItemStatus.Loading) {
      return (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '20%',
            height: '20%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Preloader preloaderStyle={{ width: '100%', height: '100%' }} />
        </div>
      );
    } else if (this.state.status === EGalleryItemStatus.Erroneous) {
      return (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          Ошибка загрузки
        </div>
      );
    }

    return null;
  }
}
